import React, { useEffect } from "react";
import DashMenu from "./components/DashMenu";
import Content from "./components/Content";
import { ActivityLoader } from "./components/ActivityLoader";
import { useRequests } from "../requests/useRequests";
import Nav from "./components/Nav";
import back_icon from "../assets/back_icon.svg";
import { useNavigate, useParams } from "react-router-dom";
import GroupedCard from "./components/GroupedCard";

export default function SingleLogsView() {
  // const location = JSON.parse(i.currentLocation[0]);
  const { id } = useParams();
  const navigate = useNavigate();
  const { fetchMyLogs, allMyFetchedLogs, isLoading } = useRequests();

  const userName = allMyFetchedLogs[0]?.user.firstname;
  const userSurname = allMyFetchedLogs[0]?.user.surname;

  const unique = [];

  const uniqueArrays = allMyFetchedLogs.filter((i) => {
    const isDuplicateHome = unique.includes(i?.home?.streetName);
    const isDuplicateWork = unique.includes(i?.work?.streetName);

    if (!isDuplicateHome || !isDuplicateWork) {
      unique.push(i?.home?.streetName);
      unique.push(i?.work?.streetName);
      return true;
    }

    return false;
  });

  useEffect(() => {
    fetchMyLogs(id);
  }, []);

  return (
    <div>
      <Nav />
      <div className="flex container mx-auto mt-3 ]" style={{ height: `calc(100vh - 100px)` }}>
        <DashMenu pageTitle="List Logs" />
        <Content>
          {isLoading ? (
            <ActivityLoader />
          ) : (
            <>
              <div className="pb-3 flex justify-between items-center">
                <h4>
                  Addreses Verification Logs:{" "}
                  <span className="font-semibold text-[#2FBF00] uppercase">
                    {userName} {userSurname}
                  </span>{" "}
                </h4>
                <button
                  onClick={() => {
                    navigate(-1);
                  }}
                  className="text-xs p-2 pr-3 items-center flex gap-2 hover:bg-gray-600  cursor-pointer bg-gray-500 rounded-[5px] text-white"
                >
                  <img src={back_icon} className="h-4 w-4" alt={"back_icon"} />
                  Back
                </button>
              </div>
              <div className=" w-full overflow-auto" style={{ height: `calc(100vh - 150px)` }}>
                {uniqueArrays.map((i) => (
                  // <ReportItemCard i={i} />
                  <GroupedCard i={i} />
                ))}
              </div>
            </>
          )}
        </Content>
      </div>
    </div>
  );
}
